import React from 'react';
import SmoothStepDottedLink from './SmoothStepDottedLink';

const FormRedirectLink = ({ id, source, target }) => {
  return (
    <SmoothStepDottedLink id={id} source={source} target={target} labelText="Redirects to..." />
  );
};

export default FormRedirectLink;
